<template>
  <div>
    <div v-if="showAll || onlyShow === 'results'">
      <div v-if="resultsLoaded" id="swiper-results" class="swiper border-t border-x flex flex-row text-xs font-medium border-zt-light bg-zt-light/35 gap-x-[7px] rounded-t-zt p-2.5">
        <div class="swiper-wrapper">
          <div v-for="league in qualificationsByLeague[leagueId]"
               @click="changeRegion(league)"
               :class="{ 'bg-zt-light' : selectedRegion.league_id === league.league_id, 'opacity-40 !cursor-default' : !league.available,
                         'zt-hover' : selectedRegion.league_id !== league.league_id && league.available }"
               class="swiper-slide w-fit px-[17px] py-[6px] uppercase border cursor-pointer border-zt-light rounded-zt">
            {{ league.league_name }}
          </div>
        </div>
      </div>
      <div>
        <FootballLeagueResults
          v-show="selectedRegion.league_id === 32"
          :rounded-top="false"
          @loaded="resultsLoaded = true"
          :extra-league-id="32"
          :extra-league-type="'National Cup'"
          :extra-country-name="'Świat'"
          placeholder-name="wyniki"
          :extra-amount="2"
          :extra-league-name="`Kwalifikacje - Europa `"
          :extra-country-query-name="'swiat'"
          :rounded-top-info="false"
          :extra-season="2024"
        />
        <FootballLeagueResults
          v-show="selectedRegion.league_id === 34"
          :rounded-top="false"
          @loaded="resultsLoaded = true"
          :extra-league-id="34"
          :extra-league-type="'National Cup'"
          :extra-country-name="'Świat'"
          placeholder-name="wyniki"
          :extra-amount="2"
          :extra-league-name="`Kwalifikacje - Ameryka Poł. `"
          :extra-country-query-name="'swiat'"
          :rounded-top-info="false"
          :extra-season="2026"
        />
      </div>
    </div>
    <div v-if="showAll || onlyShow === 'timetable'" class="mt-6">
      <p v-if="timetableLoaded" class="text-xl font-semibold pl-2.5 mb-2.5 xl:pl-0">Najbliższe mecze</p>
      <div>
        <FootballLeagueTimetable
            v-show="selectedRegion.league_id === 32"
            :extra-league-id="32"
            :extra-league-type="'National Cup'"
            @loaded="timetableLoaded = true"
            :extra-amount="2"
            :show-league-name="false"
            :extra-country-name="'Świat'"
            placeholder-name="terminarz"
            :extra-league-name="`Kwalifikacje - Europa `"
            :extra-country-query-name="'swiat'"
            :extra-season="2024"
        />
        <FootballLeagueTimetable
            v-show="selectedRegion.league_id === 34"
            :extra-league-id="34"
            :extra-league-type="'National Cup'"
            @loaded="timetableLoaded = true;"
            :extra-amount="2"
            :show-league-name="false"
            :extra-country-name="'Świat'"
            placeholder-name="terminarz"
            :extra-league-name="`Kwalifikacje - Ameryka Poł. `"
            :extra-country-query-name="'swiat'"
            :extra-season="2026"
        />
      </div>
    </div>
    <div v-if="showAll || onlyShow === 'group'" class="mt-6">
      <p class="text-xl font-semibold pl-2.5 mb-2.5 xl:pl-0"> {{ leagueName }} - Faza grupowa - {{ +leagueId === 1 ? 'eliminacje' : 'kwalifikacje' }} </p>
      <div id="swiper-groups" class="swiper border-t border-x flex flex-row text-xs font-medium border-zt-light bg-zt-light/35 gap-x-[7px] rounded-t-zt p-2.5">
        <div class="swiper-wrapper">
          <div v-for="league in qualificationsByLeague[leagueId]"
               @click="changeRegion(league, 'groups')"
               :class="{ 'bg-zt-light' : selectedRegionGroups.league_id === league.league_id, 'opacity-40 !cursor-default' : !league.available,
           'zt-hover' : selectedRegionGroups.league_id !== league.league_id && league.available }"
               class="swiper-slide px-[17px] w-fit py-[6px] uppercase border cursor-pointer border-zt-light rounded-zt">
            {{ league.league_name }}
          </div>
        </div>
      </div>
      <Transition name="fade-fast">
        <FootballLeagueGroups
            v-if="Object.keys(selectedRegionGroups).length > 0 && !reload[2]"
            :extra-league-id="selectedRegionGroups.league_id"
            :extra-league-type="'National Cup'"
            :extra-country-name="'Świat'"
            :show-promotion="false"
            :extra-matches-amount="10"
            placeholder-name="grupy"
            :animate="false"
            :rounded-top-info="false"
            :rounded-top="false"
            :selected-team-id="teamId"
            :extra-league-name="`Kwalifikacje - ${ selectedRegionGroups.league_name } `"
            :extra-country-query-name="'swiat'"
            :extra-season="selectedRegionGroups.season"
        />
      </Transition>
    </div>
  </div>
</template>
<script>
import FootballLeagueResults from "./FootballLeagueResults.vue";
import FootballLeagueTimetable from "./FootballLeagueTimetable.vue";
import FootballLeagueGroups from "./FootballLeagueGroups.vue";
import Swiper from "swiper";
import {FreeMode, Scrollbar} from "swiper/modules";

export default {
  name: 'TournamentQualifications',
  components: {FootballLeagueGroups, FootballLeagueTimetable, FootballLeagueResults},
  inject: ['WP'],
  props: {
    leagueId: String,
    leagueType: String,
    leagueName: String,
    countryName: String,
    onlyShow: {
      type: String,
      validator(value) {
        return ['results', 'timetable', 'group'].includes(value)
      }
    },
    showAll: {
      type: Boolean,
      default: true
    },
    initialRegion: {
      type: Number,
    },
    teamId: {
      type: Number,
    }
  },
  data() {
    return {
      qualificationsByLeague: {
        1 : [
          {
            league_id: 32,
            league_name: 'Europa',
            available: true,
            season: 2024
          },
          {
            league_id: 34,
            league_name: 'Ameryka Poł.',
            available: true,
            season: 2026
          },
          {
            league_id: 29,
            league_name: 'Afryka',
            available: false,
            season: 2026
          },
          {
            league_id: 30,
            league_name: 'Azja',
            available: false,
            season: 2026
          }
        ]
      },
      selectedRegion: {},
      selectedRegionGroups: {},
      leagueTables: [],
      resultsLoaded: false,
      timetableLoaded: false,
      reload: [false, false, false],
    }
  },
  mounted() {
    this.selectedRegion = this.qualificationsByLeague[this.leagueId].find(league => league.available);
    this.selectedRegionGroups = this.qualificationsByLeague[this.leagueId].find(league => league.available);

    if (this.initialRegion) {
      this.selectedRegionGroups = this.qualificationsByLeague[this.leagueId].find(league => league.league_id === this.initialRegion);
    }
    this.initSwiper('swiper-groups');
  },
  watch: {
    resultsLoaded(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.initSwiper('swiper-results');
        })
      }
    }
  },
  methods: {
    initSwiper(id) {
      new Swiper(`#${id}`, {
        modules: [Scrollbar, FreeMode],
        slidesPerView: 'auto',
        resistanceRatio: 0,
        centeredSlides: window.size.mobile,
        centeredSlidesBounds: window.size.mobile,
        freeMode: {
          enabled: true,
          minimumVelocity: 0.01,
          momentum: true,
          momentumBounce: false,
          momentumRatio: 0.7,
          momentumVelocityRatio: 0.5,
          sticky: false,
        },
        spaceBetween: 8,
      });
    },
    changeRegion(region, type = 'results') {
      if (!region.available) return;
      if (type === 'results') {
        this.selectedRegion = region;
        this.reload = [true, true, false];
      } else if (type === 'groups') {
        this.selectedRegionGroups = region;
        this.reload = [false, false, true];
      }
      setTimeout(() => {
        this.reload = [false, false, false];
      }, 100);
    }
  }
}
</script>
<style scoped>
.fade-fast-enter-active,
.fade-fast-leave-active {
  transition: all 0.3s ease;
}

.fade-fast-enter-from,
.fade-fast-leave-to {
  opacity: 0;
}
</style>